/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Detail_RatingsInputs */



/**
* | output |
* | --- |
* | "Ratings" |
*
* @param {User_Detail_RatingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_detail_ratings = /** @type {((inputs?: User_Detail_RatingsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Detail_RatingsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Classements")
	if (locale === "es") return /** @type {LocalizedString} */ ("Calificaciones")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ratings")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rating")
	return /** @type {LocalizedString} */ ("Ratings")
});